import React from 'react'
import styles from './LanguageComponent.module.css'


import turkeyFlag from '../../assets/images/trflag.png'
import ukFlag from '../../assets/images/ukflag.png'
import franceFlag from '../../assets/images/frflag.png'
import germanyFlag from '../../assets/images/gerflag.png'
import russiaFlag from '../../assets/images/rusflag.png'
import saudiFlag from '../../assets/images/sauflag.webp'

const LanguageComponent = () => {
  const flags = [
    { name: 'Turkey', flag: turkeyFlag },
    { name: 'United Kingdom', flag: ukFlag },
    { name: 'France', flag: franceFlag },
    { name: 'Germany', flag: germanyFlag },
    { name: 'Russia', flag: russiaFlag },
    { name: 'Saudi Arabia', flag: saudiFlag }
  ]

  return (
    <section className={styles.languageSection}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.textContainer}>
            <h2 className={styles.title}>We Speak Your Language</h2>
          </div>
          <div className={styles.flagsContainer}>
            {flags.map((country, index) => (
              <div key={index} className={styles.flagWrapper}>
                <img 
                  src={country.flag} 
                  alt={`${country.name} flag`} 
                  className={styles.flag}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default LanguageComponent
